export default {
    spot: "eastWall"
}